import { DatePicker, Table, TableColumnsType } from "antd";
import moment from "moment";
import QueryString from "qs";
import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from "react-router-dom";
import { getTextMessages } from "../../api/pushMessage.api";
import Button from "../../components/Button";
import ErrorResponse from "../../components/ErrorResponse";
import SimpleHeader from "../../components/layout/SimpleHeader";
import Loader from "../../components/Loader";
import ShowMessageModal from "../../components/message/sms-send/modals/ShowMessageModal";
import Pagination from "../../components/Pagination";
import useAxios from "../../hooks/useAxios";
import config from "../../lib/config";
import { IGetTextMessages, ITextMessage } from "../../models/pushMessage.model";

const SmsSend = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const { data: res, isLoading, error, execute } = useAxios<IGetTextMessages>();

  const [date, setDate] = useState(moment().format('YYYYMM'));
  const [memberName, setMemberName] = useState('');
  const [page, setPage] = useState(1);
  const [params, setParams] = useState({});
  const [showMessageVisible, setShowMessageVisible] = useState(false);
  const [record, setRecord] = useState<ITextMessage>();

  useEffect(() => {
    const _params: any = {
      pageNo: page,
      perPage: config.pageSize,
      year: date.slice(0, 4),
      month: date.slice(4, 6),
    };

    if (query.page) {
      _params.pageNo = Number(query.page);
      setPage(_params.pageNo);
    }
    if (query.date) {
      const _date = String(query.date);
      _params.year = _date.slice(0, 4);
      _params.month = _date.slice(4, 6);
      setDate(_date);
    }
    if (query.memberName) {
      const _memberName = String(query.memberName);
      setMemberName(_memberName);
    }

    execute(getTextMessages(_params));
    _params.page = _params.pageNo;
    delete _params.pageNo;
    delete _params.perPage;
    setParams(_params);
  }, [location]);

  const onSearch = () => {
    const _params: any = { page: 1 };

    if (date) {
      _params.date = date;
    }
    if (memberName) {
      _params.memberName = memberName;
    }

    history.push(`/message/sms-send?${QueryString.stringify(_params)}`);
  }

  const columns: TableColumnsType<ITextMessage> = [
    {
      title: t('message.smsSend.column1'),
      dataIndex: 'memberName',
      key: 'memberName',
      align: 'center',
      width: '200px',
      render: (value, record) => `(${record.campusName}) ${value}`,
    },
    {
      title: t('message.smsSend.column2'),
      dataIndex: 'sendDate',
      key: 'sendDate',
      align: 'center',
      width: '150px',
    },
    {
      title: t('common.column.status'),
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      width: '100px',
      render: value => {
        switch (value) {
          case '06':
          case 'Y':
          case '1000':
            return `${t('message.smsSend.column3')}(${value})`;
          case '0':
            return `${t('message.smsSend.column4')}(0)`;
          default:
            return `${t('message.smsSend.column5')}(${value})`;
        }
      }
    },
    {
      title: t('common.column.contents'),
      dataIndex: 'content',
      key: 'content',
      align: 'center',
      ellipsis: true,
      render: value => <div className="text-left ant-table-cell-ellipsis">{value}</div>
    },
  ];

  return (
    <>
    <SimpleHeader
      iconFile="icon-message-big.svg"
      parentMenu={t('common.menu.message')}
      currentMenu={t('message.smsSend.title1')}
      onlyTitle={true}
    />
    <div className="common-search">
      <div className="search-area">
        <ul className="search-bx">
          <li>
            <div className="date-picker__area">
              <DatePicker
                value={date ? moment(date) : undefined}
                onChange={e => {
                  if (e === null) setDate('');
                  else setDate(moment(e).format('YYYYMM'))
                }}
                picker="month"
              />
            </div>
          </li>
          <li>
            <label>{t('message.smsSend.column1')}</label>
            <input
              type="text"
              placeholder={t('message.smsSend.column1')}
              className="form-control w-150p"
              value={memberName}
              onChange={(e) => setMemberName(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') onSearch();
              }}
            />
            <div className="comm-btn__area">
              <Button
                className='btn-basic small black'
                onClick={onSearch}
                text={t('common.button.search')}
              />
              <Button
                className='btn-basic pink-line'
                onClick={() => history.push(`/message/sms-write`)}
                text={t('message.smsSend.button1')}
              />
            </div>
          </li>
          <li>
            
          </li>
        </ul>
      </div>
    </div>
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <div className="col-frame">
        <div className="comm-bx__between">
          <div className="comm-sch_result">
            {t('common.text.count')}: <b>{(res)?res?.total:0}</b>{t('common.text.unit')}
          </div>
        </div>
        <div className='comm-table__area'>
          <Table
            columns={columns}
            dataSource={res?.data}
            pagination={{
              current: page,
              pageSize: config.pageSize,
            }}
            onRow={(record) => {
              return {
                onClick: () => {
                  setRecord(record);
                  setShowMessageVisible(true);
                },
              };
            }}
            rowClassName="pointer"
            rowKey="pk"
          />
        </div>
        <div className="comm-bx__between">
          <div className="common-paging center">
            <Pagination
              count={res?.total || 0}
              page={page}
              param={params}
              path="/message/sms-send"
            />
          </div>
        </div>
      </div>

      {showMessageVisible &&
        <ShowMessageModal
          visible={showMessageVisible}
          setVisible={setShowMessageVisible}
          record={record}
        />
      }
    </div>
    </>
  );
}

export default SmsSend;
